import React, { useCallback, useMemo, useState } from "react";
import { Form, Input } from "antd";

const ZipCodeInput = ({
  inputRef,
  formRef,
  formItemProps: _formItemProps,
  inputProps: _inputProps,
  required,
  disabled,
  customValidator,
}) => {
  const [value, setValue] = useState("");

  const handleTextChange = useCallback(
    event => {
      const { value } = event.target;
      let clean = value.replaceAll("-", "");

      const words = clean.split(" ");
      if (words.length > 2) {
        // preserve only one space for canada zip codes
        clean = `${words[0]} ${words.slice(1, words.length).join("")}`;
      }

      const digitsOnly = clean.replace(/\D/g, "");
      let newValue = clean;

      if (digitsOnly === clean) {
        const firstPart = digitsOnly.slice(0, 5);
        const secondPart = digitsOnly.slice(5, digitsOnly.length);

        if (digitsOnly.length <= 5) {
          newValue = digitsOnly;
        } else {
          // autocomplete - for us zip codes
          newValue = `${firstPart}-${secondPart}`;
        }
      }

      setValue(newValue);

      if (formRef?.current && _formItemProps?.name) {
        formRef.current.setFieldsValue({
          [_formItemProps?.name]: newValue,
        });
      }

      if (typeof _inputProps?.onChange === "function") {
        _inputProps.onChange(newValue);
      }
    },
    [_formItemProps?.name, _inputProps?.onChange],
  );

  const inputProps = useMemo(() => {
    return {
      value,
      maxLength: 10,
      placeholder: "Zip Code (ex: '12345', '12345-1234')",
      ..._inputProps,
      onChange: handleTextChange,
    };
  }, [value, _inputProps, handleTextChange]);

  const formItemProps = useMemo(() => {
    return {
      label: "Zip Code",
      rules: [
        {
          required,
          validator:
            customValidator ||
            ((_, value) => {
              if (!value) {
                if (required) {
                  return Promise.reject("Please enter zip code");
                } else {
                  return Promise.resolve();
                }
              }

              value = value?.toString();

              const digitsOnly = value?.replace(/\D/g, "");
              if (digitsOnly === value && value.length === 5) {
                // valid us zip code format DDDDD
                // valid mexican zip code format DDDD or DDDDD
                return Promise.resolve();
              }

              if (
                value === `${digitsOnly.slice(0, 5)}-${digitsOnly.slice(5, digitsOnly.length)}` &&
                value.length === 10
              ) {
                // valid us zip code DDDDD-DDDD format
                return Promise.resolve();
              }

              return Promise.reject("Please enter a valid zip code");
            }),
        },
      ],
      ..._formItemProps,
    };
  }, [_formItemProps]);

  return (
    <Form.Item {...formItemProps}>
      <Input ref={inputRef} {...{ disabled }} {...inputProps} />
    </Form.Item>
  );
};

ZipCodeInput.defaultProps = {
  required: true,
};

export default ZipCodeInput;
